export const MAGIC_SEARCH_DEBOUNCE_MS = 300;

/** One venue can be shared by a hundred companies; past this many, the rest are counted instead of listed. */
export const MAGIC_SEARCH_VENUE_COMPANIES_SHOWN = 5;

/** Names need two characters; ids are searched from the first digit, and UUIDs are always long enough. */
export const MAGIC_SEARCH_MIN_TERM_LENGTH = 2;

export const MAGIC_SEARCH_ITEM_CLASS =
  'flex cursor-pointer items-center gap-3 rounded-lg px-3 py-2 data-[selected=true]:bg-tertiary data-[disabled=true]:cursor-not-allowed';

export const MAGIC_SEARCH_GROUP_CLASS =
  'pb-1 [&_[cmdk-group-heading]]:px-3 [&_[cmdk-group-heading]]:pt-3 [&_[cmdk-group-heading]]:pb-1.5 [&_[cmdk-group-heading]]:text-subtitle-xs [&_[cmdk-group-heading]]:text-tertiary';

export const MAGIC_SEARCH_KEY_CLASS =
  'inline-flex h-5 min-w-5 items-center justify-center rounded border border-extra-soft bg-surface-secondary px-1 font-sans text-body-xs text-secondary';
